import SlidePanel from './SlidePanel';
export { SlidePanel };
export default SlidePanel;
